import {errorize} from "../bomb/errorize.tsx";
import {ScheduledTransfer, useFullScheduledTransfersForDriver} from "../rpc/webrpc-client.gen.ts";
import {cleanse} from "../util/arutil.tsx";
import {InfallibleUseResult, pendingUseResult, successUseResult} from "../util/hookutil.tsx";
import {cmpScheduledTransfer} from "../transit/schedule.tsx";

export function useScheduledTransfersForDriver(args?: { driverId: string }): InfallibleUseResult<ScheduledTransfer[]> {
    const tqrv = useFullScheduledTransfersForDriver(args);
    if (tqrv.isPending) {
        return pendingUseResult;
    }
    if (tqrv.isError) {
        throw errorize(tqrv.errors);
    }
    const unsorted = cleanse(tqrv.data);
    const sorted = unsorted.toSorted(cmpScheduledTransfer);
    return successUseResult(sorted);
}


